import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { ActivityFeedService } from '../../../client/services/activity-feed.service';
import {
  ActivityFeedItem,
  ActivityPeriod,
  ActivityFilterGroup,
  ACTIVITY_FILTER_GROUPS
} from '../../../client/models/activity-feed.model';

@Component({
  selector: 'app-campaign-activity-feed',
  templateUrl: './campaign-activity-feed.component.html',
  styleUrls: ['./campaign-activity-feed.component.scss']
})
export class CampaignActivityFeedComponent implements OnInit, OnDestroy, OnChanges {
  @Input() quizId!: number;
  @Output() activityClick = new EventEmitter<ActivityFeedItem>();

  activities: ActivityFeedItem[] = [];
  isLoading = false;
  selectedPeriod: ActivityPeriod = '24h';
  selectedFilterGroup: ActivityFilterGroup = ACTIVITY_FILTER_GROUPS[0];
  filterGroups = ACTIVITY_FILTER_GROUPS;

  private destroy$ = new Subject<void>();

  constructor(private activityFeedService: ActivityFeedService) {}

  ngOnInit(): void {
    if (this.quizId) {
      this.loadActivities();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['quizId'] && !changes['quizId'].firstChange) {
      this.loadActivities();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadActivities(): void {
    if (!this.quizId) return;

    this.isLoading = true;
    const types = this.selectedFilterGroup.types.length > 0
      ? this.selectedFilterGroup.types
      : undefined;

    this.activityFeedService
      .getCampaignFeed(this.quizId, this.selectedPeriod, types)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (activities) => {
          this.activities = activities;
          this.isLoading = false;
        },
        error: () => {
          this.activities = [];
          this.isLoading = false;
        }
      });
  }

  onPeriodChange(event: MatButtonToggleChange): void {
    this.selectedPeriod = event.value;
    this.loadActivities();
  }

  onFilterChange(filterGroup: ActivityFilterGroup): void {
    this.selectedFilterGroup = filterGroup;
    this.loadActivities();
  }

  getActivityIcon(type: string): string {
    return this.activityFeedService.getActivityIcon(type);
  }

  getActivityColor(type: string): string {
    return this.activityFeedService.getActivityColor(type);
  }

  getActivityDetail(activity: ActivityFeedItem): string | null {
    return this.activityFeedService.getActivityDetail(activity);
  }

  onActivityClick(activity: ActivityFeedItem): void {
    if (activity.candidateId) {
      this.activityClick.emit(activity);
    }
  }

  isClickable(activity: ActivityFeedItem): boolean {
    return !!activity.candidateId;
  }

  getSummaryKey(activityType: string): string {
    return this.activityFeedService.getSummaryKey(activityType);
  }

  getSummaryParams(activity: ActivityFeedItem): Record<string, string> {
    return this.activityFeedService.getSummaryParams(activity);
  }
}
